module.exports = __webpack_public_path__ + "static/img/background-goods-off.30ebbdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-goods-off.jpg
// module id = fukI
// module chunks = 10